import React, { Component } from "react";
import { connect } from "react-redux";
import { Table, Switch, Spin, Typography, message } from "antd";
import * as actions from "../actions";

const { Title } = Typography;

class SyncBlockList extends Component {
  componentDidMount() {
    this.props.loadSyncBlocks();
  }

  componentDidUpdate(prevProps) {
    const { errorMessage } = this.props.syncBlocks;
    if (errorMessage && errorMessage !== prevProps.syncBlocks.errorMessage) {
      message.error(errorMessage);
    }
  }

  render() {
    const { data, loading } = this.props.syncBlocks;

    const columns = [
      {
        title: "#",
        key: "index",
        className: "align-center",
        width: 50,
        render: (text, record, index) => index + 1
      },
      {
        title: "Code",
        dataIndex: "branch_code",
        width: 120
      },
      {
        title: "Name",
        dataIndex: "branch_name"
      },
      {
        title: "Block Sync Use Package",
        key: "is_blocked",
        className: "align-center",
        width: 200,
        render: (record) => (
          <Switch
            checked={record.is_blocked}
            loading={loading}
            onChange={() => this.props.toggleSyncBlock(record.branch_id)}
            checkedChildren="บล็อก"
            unCheckedChildren="ปกติ"
          />
        )
      }
    ];

    return (
      <div>
        <Spin size="large" spinning={loading}>
          <div style={{ marginBottom: 16 }}>
            <Title level={4}>Sync Block — Use Package</Title>
          </div>
          <Table
            rowKey="branch_id"
            bordered
            size="small"
            columns={columns}
            dataSource={data}
            pagination={false}
          />
        </Spin>
      </div>
    );
  }
}

const mapStateToProps = ({ syncBlocks }) => ({ syncBlocks });

const mapDispatchToProps = {
  loadSyncBlocks: actions.loadSyncBlocks.request,
  toggleSyncBlock: actions.toggleSyncBlock.request
};

export default connect(mapStateToProps, mapDispatchToProps)(SyncBlockList);
